import {AuthService} from '../../shared/auth/auth.service';
import {Observable} from 'rxjs';
import {Http, Response} from '@angular/http';

export abstract class BaseService<T> {

  constructor(protected _baseUrl: string,
              protected _authService: AuthService,
              protected _http: Http) {
  }

  findAll(): Observable<T[]> {
    return this._http.get(this._baseUrl, {headers: this._authService.getAuthorizationHeaders()})
      .map((res: Response) => res.json())
      ;
  }

  findOne(id: any): Observable<T> {
    let requestUrl = this._baseUrl + '/' + id;
    return this._http.get(requestUrl, {headers: this._authService.getAuthorizationHeaders()})
      .map((res: Response) => res.json())
      ;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/service/base.service.ts